import styled from 'styled-components';
import { HashLink as Link } from 'react-router-hash-link';

export {
  Secao,
  SecaoTitulo,
  SecaoSubTitulo,
  SecaoBotaoVoltar,
  SecaoCabecalho,
} from '@alweb-merkator/shared/components/Secao';

export { default as Video } from '@alweb-merkator/shared/components/Video';

export { Col, Row } from 'reactstrap';

export { Tradutor } from '@alweb-merkator/shared/components/I18n';

export const Pilar = styled.div`
  text-align: center;
  min-height: 100%;
  padding: 15px;
  background-color: ${(props) => props.theme.colors.primary};
`;

export const PilarTitulo = styled.h2`
  color: ${(props) => props.theme.colors.textInBg};
`;

export const PilarConteudo = styled.p`
  color: ${(props) => props.theme.colors.textInBg};
`;

export const BotaoLink = styled(Link)`
  line-height: 2em;

  font-size: 1.3rem;

  @media (min-width: 768px) {
    font-size: 1.4rem;
  }
`;

export const Conteudo = styled.div`
  @media (min-width: 768px) {
    padding-right: 10%;
  }

  @media (min-width: 992px) {
    padding-right: 15%;
  }

  @media (min-width: 1200px) {
    padding-right: 20%;
  }
`;
